'use strict'

Zip64Limit = 0xffffffff

class ZipBuffer
  constructor: ->
    @buffer = []

  writeByte: (byte) ->
    @buffer.push byte
    this

  writeWord: (word) ->
    @writeByte word & 0xff
    @writeByte (word >>> 8) & 0xff
    this

  writeDWord: (dword) ->
    @writeByte dword & 0xff
    @writeByte (dword >>> 8) & 0xff
    @writeByte (dword >>> 16) & 0xff
    @writeByte (dword >>> 24) & 0xff
    this

  writeQWord: (qword) ->
    @writeDWord qword & 0xffffffff
    @writeDWord (qword / 0x100000000) & 0xffffffff
    this

  writeString: (string) ->
    for i in [0..(string.length - 1)]
      @writeByte string.charCodeAt i
    this

  writeBuffer: (otherBuffer) ->
    for byte in otherBuffer.buffer
      @writeByte byte
    this

  writeArray: (array) ->
    for byte in array
      @writeByte byte
    this

  getBuffer: ->
    @buffer

  getLength: ->
    @buffer.length

  getArrayBuffer: ->
    ab = new ArrayBuffer @buffer.length
    view = new Uint8Array ab
    i = 0
    while i < @buffer.length
      view[i] = @buffer[i]
      i++
    ab

getZipVersion = (useZip64, useEncryption) ->
  switch
    when useZip64
      45 # ZIP64 requires v4.5
    when useEncryption
      20 # AES encryption requires v2.0
    else
      10 # v1.0 is the default version

getGeneralPurposeFlags = (encryptionBits, compressionLevel, delayCrc) ->
  generalPurposeFlags = 0x0800 # Bit 11 specifies UTF-8 filename encoding
  generalPurposeFlags |= 0x0001 if encryptionBits
  if compressionLevel > 0
    generalPurposeFlags |= switch
      when compressionLevel < 2 then 0
      when compressionLevel < 6 then 1
      when compressionLevel == 6 then 2
      else 3
  generalPurposeFlags |= 0x0008 if delayCrc
  generalPurposeFlags

getCompressionMethod = (useEncryption, compressionLevel) ->
  switch
    when useEncryption
      99 # Compressed with AES encryption
    when compressionLevel > 0
      8 # Deflation
    else
      0 # Stored

getDateTime = (lastModifiedDate) ->
  # Determine the date and time
  dt = new Date lastModifiedDate
  date: dt.getDate() | ((dt.getMonth() + 1) << 5) | ((dt.getYear() - 80) << 9)
  time: (dt.getSeconds() / 2) | (dt.getMinutes() << 5) | (dt.getHours() << 11)

getCompressedSize = (encryptionBits, fileItem, useDelayCrc) ->
  if useDelayCrc and fileItem.delayCrc
    0
  else
    size = fileItem.compressedSize || fileItem.size
    size += fileItem.aesSalt.length + 2 + 10 if encryptionBits
    size

getPath = (fileItem, suffix) ->
  path = fileItem.getCompletePath().replace '\\', '/'
  path += suffix if suffix
  utf8 = []
  for i in [0..(path.length - 1)]
    charCode = path.charCodeAt i
    if charCode < 0x80
      utf8.push charCode
    else if charCode < 0x0800
      utf8.push 0xc0 | (charCode >> 6), 0x80 | (charCode & 0x3f)
    else if charCode < 0xd800 or charCode >= 0xe000
      utf8.push(
        0xe0 | (charCode >> 12)
        0x80 | ((charCode >> 6) & 0x3f)
        0x80 | (charCode & 0x3f)
      )
    else
      utf8.push 0xef, 0xbf, 0xbd
  utf8

getExtraField = (
  isCD
  encryptionBits
  lastModifiedDate
  compressionLevel
  compressedSize
  uncompressedSize
  zipOffset
) ->
  # Create the extra field
  extraField = new ZipBuffer()

  # Write the missing ZIP64 lengths
  zip64tag = new ZipBuffer()
  zip64tag.writeQWord uncompressedSize if (
    (isCD and uncompressedSize > Zip64Limit) or
    (!isCD and (compressedSize > Zip64Limit or uncompressedSize > Zip64Limit))
  )
  zip64tag.writeQWord compressedSize if (
    (isCD and compressedSize > Zip64Limit) or
    (!isCD and (compressedSize > Zip64Limit or uncompressedSize > Zip64Limit))
  )
  zip64tag.writeQWord zipOffset if isCD and zipOffset > Zip64Limit
  if zip64tag.getLength() > 0
    extraField.writeWord 0x0001 # Tag (0x0001 - Extended Information Extra Field)
    extraField.writeWord zip64tag.getLength() # Field length
    extraField.writeBuffer zip64tag # The actual tag

  # Add extended timestamp (0x5455) to the extra fields
  if lastModifiedDate
    extraField.writeWord 0x5455 # Tag
    extraField.writeWord 5 # Data size
    extraField.writeByte 1 # Only last modification timestamp is known
    extraField.writeDWord Math.floor new Date(lastModifiedDate).getTime() / 1000

  # Add encryption information (0x9901) to the extra fields
  if encryptionBits
    aesStrength = switch encryptionBits
      when 128 then 1
      when 192 then 2
      when 256 then 3
      else 0
    compression = if compressionLevel > 0 then 8 else 0

    extraField.writeWord 0x9901 # Tag
    extraField.writeWord 7 # Data size
    extraField.writeWord 2 # AES encryption version
    extraField.writeString 'AE' # Vendor id
    extraField.writeByte aesStrength # AES strength
    extraField.writeWord compression # Compression method

  # Return the extra-field
  extraField

export default
  getFolderZipHeader: (folder, isCD) ->
    lfh = new ZipBuffer()

    # We need a ZIP64 header, if:
    # - The CD is written and the offset is above the ZIP64 limit
    useZip64 = isCD and folder.zipOffset > Zip64Limit

    # Write LFH or CD signature
    lfh.writeDWord if isCD then 0x02014b50 else 0x4034b50

    if isCD
      # Write 'version made by' values
      lfh.writeByte 30 # 30 - ZIP spec
      lfh.writeByte 3 # 3 - Unix

    # Determine the ZIP version
    lfh.writeWord getZipVersion useZip64, 0

    # Write general purpose flags
    lfh.writeWord 0x0800 # Bit 11 - UTF8 file encoding

    # Write compression method
    lfh.writeWord 0

    # Write date/time
    dateTime = getDateTime folder.lastModifiedDate
    lfh.writeWord dateTime.time
    lfh.writeWord dateTime.date

    # Write the CRC
    lfh.writeDWord 0

    # Write the file-sizes
    lfh.writeDWord 0
    lfh.writeDWord 0

    # Determine the exact path
    path = getPath folder, '/'

    # Determine the extra fields
    extraField = getExtraField(
      isCD
      0
      folder.lastModifiedDate
      0
      0
      0
      folder.zipOffset
    )

    # Write the path/extra-field lengths
    lfh.writeWord path.length
    lfh.writeWord extraField.getLength()

    if isCD
      # Write file-comment length
      lfh.writeWord 0

      # Write the starting disk
      lfh.writeWord 0

      # Write the internal file attributes
      lfh.writeWord 0

      # Write the external file attributes
      # (from http://unix.stackexchange.com/a/14727)
      #
      # define S_IFDIR  0040000  /* directory */  # this is an octal value: = 0x4000
      # define S_IFREG  0100000  /* regular */    # this is an octal value: = 0x8000
      #
      # "10000001101001000000000000000000" # 0x81a40000: file
      # "01000001111011010000000000010000" # 0x41ed0010: folder
      #  TTTTsstrwxrwxrwx0000000000ADVSHR
      #  ^^^^____________________________ file type as explained above
      #      ^^^_________________________ setuid, setgid, sticky
      #         ^^^^^^^^^________________ permissions
      #                  ^^^^^^^^________ This is the "lower-middle byte" your post mentions
      #                          ^^^^^^^^ DOS attribute bits
      lfh.writeDWord 0x41ed0010

      # Write the offset
      lfh.writeDWord if useZip64 then 0xffffffff else folder.zipOffset

    # Write the path/extra-field
    lfh.writeArray path
    lfh.writeBuffer extraField
    lfh

  getFileZipHeader: (encryptionBits, fileItem, isCD) ->
    lfh = new ZipBuffer()

    # We need a ZIP64 header, if:
    # - The size is above the ZIP64 limit
    # - The CD is written and the offset is above the ZIP64 limit
    useZip64 =
      fileItem.size > Zip64Limit or
      fileItem.compressedSize > Zip64Limit or
      (isCD and fileItem.zipOffset > Zip64Limit)

    # Write LFH or CD signature
    lfh.writeDWord if isCD then 0x02014b50 else 0x4034b50

    if isCD
      # Write 'version made by' values
      lfh.writeByte 30 # 30 - ZIP spec
      lfh.writeByte 3 # 3 - Unix

    # Write the ZIP version
    lfh.writeWord getZipVersion useZip64, encryptionBits

    # Write general purpose flags
    lfh.writeWord(
      getGeneralPurposeFlags(
        encryptionBits
        fileItem.compressionLevel
        fileItem.delayCrc
      )
    )

    # Write compression method
    lfh.writeWord getCompressionMethod encryptionBits, fileItem.compressionLevel

    # Write date/time
    dateTime = getDateTime fileItem.lastModifiedDate
    lfh.writeWord dateTime.time
    lfh.writeWord dateTime.date

    # Write the CRC
    lfh.writeDWord if isCD or !fileItem.delayCrc then fileItem.crc else 0

    # Determine the compressed size
    compressedSize = 0
    if isCD or not fileItem.delayCrc
      compressedSize = fileItem.compressedSize or fileItem.size or 0
      compressedSize += fileItem.aesSalt.length + 2 + 10 if encryptionBits

    # Determine the uncompressed size
    uncompressedSize = 0
    if isCD or not fileItem.delayCrc
      uncompressedSize = fileItem.size or 0

    # Write the file-sizes
    lfh.writeDWord(
      if compressedSize > Zip64Limit then 0xffffffff else compressedSize
    )
    lfh.writeDWord(
      if uncompressedSize > Zip64Limit then 0xffffffff else uncompressedSize
    )

    # Determine the exact path
    path = getPath fileItem

    # Determine the extra fields
    extraField = getExtraField(
      isCD
      encryptionBits
      fileItem.lastModifiedDate
      fileItem.compressionLevel
      compressedSize
      uncompressedSize
      fileItem.zipOffset
    )

    # Write the path/extra-field lengths
    lfh.writeWord path.length
    lfh.writeWord extraField.getLength()

    if isCD
      # Write file-comment length
      lfh.writeWord 0

      # Write the starting disk
      lfh.writeWord 0

      # Write the internal file attributes
      lfh.writeWord 0

      # Write the external file attributes
      # (from http://unix.stackexchange.com/a/14727)
      #
      # define S_IFDIR  0040000  /* directory */  # this is an octal value: = 0x4000
      # define S_IFREG  0100000  /* regular */    # this is an octal value: = 0x8000
      #
      # "10000001101001000000000000000000" # 0x81a40000: file
      # "01000001111011010000000000010000" # 0x41ed0010: folder
      #  TTTTsstrwxrwxrwx0000000000ADVSHR
      #  ^^^^____________________________ file type as explained above
      #      ^^^_________________________ setuid, setgid, sticky
      #         ^^^^^^^^^________________ permissions
      #                  ^^^^^^^^________ This is the "lower-middle byte" your post mentions
      #                          ^^^^^^^^ DOS attribute bits
      lfh.writeDWord 0x81a40000

      # Write the offset
      lfh.writeDWord(
        if fileItem.zipOffset > Zip64Limit
          0xffffffff
        else
          fileItem.zipOffset
      )

    # Write the path/extra-field
    lfh.writeArray path
    lfh.writeBuffer extraField

    # Write the AES salt and password verification
    # (is part of the data so don't add it in the CD)
    if !isCD
      lfh.writeArray fileItem.aesSalt if fileItem.aesSalt
      lfh.writeWord fileItem.aesPwVer if fileItem.aesPwVer
    lfh

  getFileZipTrailer: (encryptionBits, fileItem) ->
    # Create the zip trailer
    zt = new ZipBuffer()
    if fileItem.delayCrc
      # Write data descriptor signature
      zt.writeDWord 0x08074b50

      # Check if we need to use a ZIP64 trailer
      useZip64 =
        fileItem.size > Zip64Limit or fileItem.compressedSize > Zip64Limit

      # Determine the compressed size
      compressedSize = fileItem.compressedSize or fileItem.size
      compressedSize += fileItem.aesSalt.length + 2 + 10 if encryptionBits

      zt.writeDWord fileItem.crc
      if useZip64
        zt.writeQWord compressedSize
        zt.writeQWord fileItem.size
      else
        zt.writeDWord compressedSize
        zt.writeDWord fileItem.size

    # Write the first 10 bytes of the password hash
    zt.writeArray fileItem.aesHash.slice 0, 10 if fileItem.aesHash
    zt

  getCentralDirectory: (encryptionBits, files, folders, offset) ->
    cd = new ZipBuffer()
    records = 0

    for id, folder of folders
      # Write the ZIP header (central-directory style)
      cd.writeBuffer @getFolderZipHeader folder, true

      # Increment the number of records
      ++records

    for fileItem in files when !fileItem.originalFile
      # Write the ZIP header (central-directory style)
      cd.writeBuffer @getFileZipHeader encryptionBits, fileItem, true

      # Increment the number of records
      ++records

    # Keep track of the central directory size
    centralDirectorySize = cd.getLength()

    # Determine if the offset + central directory exceeds the ZIP64 limit
    useZip64 = offset + centralDirectorySize > Zip64Limit

    if useZip64
      # Add the end-of-central directory signature (ZIP64 style)
      cd.writeDWord 0x06064b50

      # Create the buffer
      zip64cd = new ZipBuffer()

      # Write 'version made by' values
      zip64cd.writeByte 30 # 30 - ZIP spec
      zip64cd.writeByte 3 # 3 - Unix

      # Version needed to extract
      zip64cd.writeWord getZipVersion useZip64, encryptionBits

      # Number of disks
      zip64cd.writeDWord 0

      # Disk of the directory
      zip64cd.writeDWord 0

      # Number of central directories on this disk and total
      zip64cd.writeQWord records
      zip64cd.writeQWord records

      # Write the size of the central directories
      zip64cd.writeQWord centralDirectorySize

      # Write the starting offset of the central directory
      zip64cd.writeQWord offset

      # Write the length of the ZIP64 end-of-central-directory record
      cd.writeQWord zip64cd.getLength()

      # Write the ZIP64 end-of-central-directory record
      cd.writeBuffer zip64cd

      # Add the end-of-central directory locator (ZIP64 style)
      cd.writeDWord 0x07064b50

      # Number of the disk with the start of the zip64 end of central directory
      cd.writeDWord 0

      # Relative offset of the zip64 end of central directory record
      cd.writeQWord offset + centralDirectorySize

      # Total number of disks
      cd.writeDWord 1

    # Add the end-of-central directory signature
    cd.writeDWord 0x06054b50

    # Number of disks
    cd.writeWord 0

    # Disk of the directory
    cd.writeWord 0

    # Number of central directories on this disk and total
    cd.writeWord if useZip64 and records > 0x10000 then 0xffff else records
    cd.writeWord if useZip64 and records > 0x10000 then 0xffff else records

    # Write the size of the central directories
    cd.writeDWord centralDirectorySize

    # Write the starting offset of the central directory
    cd.writeDWord if useZip64 then 0xffffffff else offset

    # Write comment
    comment = 'Downloaded using TransferXL'
    cd.writeWord comment.length
    cd.writeString comment

    # Return the central directory
    cd
